/* ============================================
   MEMORYONE — Main JavaScript
   Built for Recovery. Engineered for Performance.
   ============================================ */

(function () {
  'use strict';

  // === NAV SCROLL BEHAVIOR ===
  const nav = document.querySelector('.site-nav');
  const promoBar = document.querySelector('.promo-bar');

  if (nav) {
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;pointer-events:none;';
    document.body.prepend(sentinel);

    const observer = new IntersectionObserver(
      ([entry]) => {
        nav.classList.toggle('site-nav--scrolled', !entry.isIntersecting);
        nav.classList.toggle('site-nav--transparent', entry.isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  }

  // === PROMO BAR DISMISS ===
  const promoClose = document.querySelector('.promo-bar__close');
  if (promoClose && promoBar) {
    if (sessionStorage.getItem('promo-dismissed')) {
      promoBar.classList.add('is-hidden');
      document.documentElement.style.setProperty('--promo-height', '0px');
      document.documentElement.style.setProperty('--nav-offset', 'var(--nav-height)');
    }

    promoClose.addEventListener('click', () => {
      promoBar.classList.add('is-hidden');
      document.documentElement.style.setProperty('--promo-height', '0px');
      document.documentElement.style.setProperty('--nav-offset', 'var(--nav-height)');
      sessionStorage.setItem('promo-dismissed', '1');
    });
  }

  // === MOBILE MENU ===
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileMenu = document.querySelector('.nav-mobile');
  const mobileClose = document.querySelector('.nav-mobile__close');

  function openMobileMenu() {
    if (mobileMenu) {
      mobileMenu.classList.add('is-open');
      document.body.classList.add('menu-open');
    }
  }

  function closeMobileMenu() {
    if (mobileMenu) {
      mobileMenu.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }
  }

  if (hamburger) hamburger.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', closeMobileMenu);
    });
  }

  // === FAQ ACCORDION ===
  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      const item = question.closest('.faq-item');
      const answer = item.querySelector('.faq-answer');
      const isOpen = item.classList.contains('is-open');

      // Close all others
      document.querySelectorAll('.faq-item.is-open').forEach(openItem => {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          const openAnswer = openItem.querySelector('.faq-answer');
          if (openAnswer) openAnswer.style.maxHeight = '0';
        }
      });

      // Toggle current
      item.classList.toggle('is-open', !isOpen);
      if (!isOpen) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        answer.style.maxHeight = '0';
      }
    });
  });

  // === STICKY PRODUCT CTA ===
  const stickyCta = document.querySelector('.sticky-cta');
  const purchaseSection = document.querySelector('#purchase');

  if (stickyCta && purchaseSection) {
    const stickyObserver = new IntersectionObserver(
      ([entry]) => {
        stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px 0px -68px 0px' }
    );
    stickyObserver.observe(purchaseSection);
  }

  // === SCROLL REVEAL ANIMATION ===
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => revealObserver.observe(el));
  }

  function getProductVariants() {
    const variantsEl = document.querySelector('[data-product-variants]');
    if (!variantsEl) return [];
    try {
      return JSON.parse(variantsEl.textContent);
    } catch (error) {
      return [];
    }
  }

  function variantMatchesSize(variant, size) {
    if (!variant || !size) return false;
    if (variant.title === size || variant.option1 === size) return true;
    return Array.isArray(variant.options) && variant.options.includes(size);
  }

  function updateProductFormForSize(size, price, priceLabel) {
    const variants = getProductVariants();
    const variant = variants.find(item => variantMatchesSize(item, size));
    const form = document.querySelector('[data-shopify-product-form]');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');
    if (variant && idInput) idInput.value = variant.id;

    const submit = form.querySelector('[type="submit"]');
    const currencySymbol = document.querySelector('[data-currency-symbol]')?.dataset.currencySymbol || '';
    const formattedPrice = priceLabel || (price ? (currencySymbol ? currencySymbol + ' ' : '') + Number(price).toLocaleString() : '');
    if (submit && formattedPrice) {
      submit.textContent = 'Add to Cart — ' + formattedPrice;
    }
  }

  // === SIZE SELECTOR + PRICE UPDATE ===
  const sizeButtons = document.querySelectorAll('.size-btn');
  const priceDisplay = document.querySelector('[data-price-display]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickySize = document.querySelector('[data-sticky-size]');
  const setPriceDisplay = (element, currentLabel, compareLabel) => {
    if (!element || !currentLabel) return;
    element.textContent = '';
    if (compareLabel) {
      const compare = document.createElement('span');
      compare.className = 'price-compare';
      compare.textContent = compareLabel;
      element.appendChild(compare);
    }
    const current = document.createElement('span');
    current.className = 'price-current';
    current.textContent = currentLabel;
    element.appendChild(current);
  };

  sizeButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      // Update active state
      sizeButtons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      // Update price
      const price = btn.dataset.price;
      const priceLabel = btn.dataset.priceLabel;
      const compareLabel = btn.dataset.compareLabel;
      const size = btn.dataset.size;
      const currencySymbol = document.querySelector('[data-currency-symbol]')?.dataset.currencySymbol || '';
      const formattedPrice = priceLabel || (price ? (currencySymbol ? currencySymbol + ' ' : '') + Number(price).toLocaleString() : '');
      setPriceDisplay(priceDisplay, formattedPrice, compareLabel);
      if (stickyPrice && formattedPrice) stickyPrice.textContent = formattedPrice;
      if (stickySize && size) stickySize.textContent = size;
      updateProductFormForSize(size, price, priceLabel);
    });
  });

  const activeSizeButton = document.querySelector('.size-btn.is-active');
  if (activeSizeButton) {
    updateProductFormForSize(activeSizeButton.dataset.size, activeSizeButton.dataset.price, activeSizeButton.dataset.priceLabel);
  }

  // === PRODUCT IMAGE GALLERY ===
  const galleryMain = document.querySelector('.product-gallery__main img');
  const galleryThumbs = document.querySelectorAll('.product-gallery__thumb');

  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      galleryThumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (galleryMain) {
        galleryMain.src = thumb.querySelector('img').src;
      }
    });
  });

  // === CART DRAWER ===
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartClose = document.querySelector('.cart-drawer__close');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.classList.add('menu-open');
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.classList.remove('menu-open');
  }

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // === BOOKING FORM INTERCEPT ===
  const bookingForm = document.querySelector('[data-form="recovery-lab"]');
  if (bookingForm) {
    bookingForm.addEventListener('submit', (e) => {
      const targetForm = e.target;
      if (targetForm && targetForm.matches('form[action*="/contact"]')) return;
      e.preventDefault();
      const formEl = bookingForm.querySelector('form') || bookingForm;
      const successEl = bookingForm.querySelector('.form-success') || document.querySelector('.form-success');

      if (formEl.tagName === 'FORM') {
        formEl.style.display = 'none';
      }
      if (successEl) {
        successEl.classList.add('is-visible');
      }
    });
  }

  // === SMOOTH SCROLL WITH OFFSET ===
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (href === '#' || href === '#checkout') return;

      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-offset'), 10) || 108;
        const top = target.getBoundingClientRect().top + window.scrollY - offset - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // === QUANTITY STEPPER ===
  document.querySelectorAll('.qty-stepper').forEach(stepper => {
    const input = stepper.querySelector('input');
    const buttons = stepper.querySelectorAll('button');
    const decBtn = stepper.querySelector('[data-qty="dec"]') || buttons[0];
    const incBtn = stepper.querySelector('[data-qty="inc"]') || buttons[1];
    const form = stepper.parentElement ? stepper.parentElement.querySelector('[data-shopify-product-form]') : null;
    const quantityInput = form ? form.querySelector('input[name="quantity"]') : null;

    function syncQuantity() {
      if (quantityInput && input) quantityInput.value = input.value || '1';
    }

    if (decBtn) {
      decBtn.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
        syncQuantity();
      });
    }

    if (incBtn) {
      incBtn.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        syncQuantity();
      });
    }

    if (input) input.addEventListener('change', syncQuantity);
    syncQuantity();
  });

})();


(function () {
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('[data-shopify-product-form]')) return;
    event.preventDefault();
    void submitProductForm(form);
  });

  async function submitProductForm(form) {
    const submit = form.querySelector('[type="submit"]');
    const formData = new FormData(form);
    if (submit) submit.setAttribute('disabled', 'disabled');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
        signal: AbortSignal.timeout(10000),
      });
      if (!response.ok) throw new Error(await response.text());
      window.location.href = '/cart';
    } catch (error) {
      const message = form.querySelector('[data-product-form-error]');
      if (message) message.textContent = 'Unable to add this item. Please refresh and try again.';
      if (submit) submit.removeAttribute('disabled');
    }
  }
})();
